import React, { useEffect } from "react";
import { useQuery } from "../../../hooks";

interface QueryProps {
  rt: string;
  at: string;
}

export const Login: React.FC = () => {
  const [query] = useQuery<QueryProps>();
  useEffect(() => {
    if (query.at || query.rt) {
      localStorage.setItem("token", query.at);
      localStorage.setItem("refreshToken", query.rt);
      window.location.href = "/";
    }
  }, [query]);
  return <>Loading...</>;
};
